<template lang="pug">
  div
    app-header

    section(class='u-bg-secondary')
      div(class='u-flex u-items-center o-wrapper u-py4')
        button(class='c-btn-nav' id='post-last__prev')
          i(class='u-icon') arrow_extend_left
        div(class='u-flex-1 u-1/12 u-px4')
          swiper(:options='swiperLast')
            swiper-slide(v-for='(post, index) in postsLast', :key='index')
              router-link(:to="{ name: 'Post', params: {slug: post.slug} }" class='u-block')
                figure(class='u-block' v-if='post.imageUrl')
                  //- img(v-lazy='post.imageUrl' class='u-12/12 lazyload', :data-src='post.imageThumbUrl')
                  img(class='lazyload', :src='post.imageUrl', :data-src='post.imageThumbUrl')

                p(class='u-white u-mb0 u-fz-h6 u-fw-s-bold') {{post.title}}
        button(class='c-btn-nav' id='post-last__next')
          i(class='u-icon') arrow_extend_right

    section.u-flex.u-justify-start.o-wrapper.u-mt5
      article(class='u-flex-1 u-1/12')
        h1.u-fz-h3.u-uppercase.u-mt0.u-color-primary {{ currentPost.title }}
        .u-mb3
          span.u-fw-bold.u-uppercase.u-color-dark {{ currentPost.category }}&nbsp;
          span.u-uppercase | {{ currentPost.date | date }} |&nbsp;
          span {{ currentPost.hora}} h

        div(v-if='currentPost && currentPost.imagesUrl.length > 0')
          swiper.u-mb4(:options='swiperPost'  class='u-bg-tertiary')
            swiper-slide(v-for='(image, index) in currentPost.imagesUrl', :key='index')
              figure()
                img(:src='image')

        div(v-html='currentPost.content')

        div(class='u-show@movil u-px0 u-py0 u-bg-border u-mb3' v-if='currentPost.videoUrl')
          a.u-flex.u-items-center.u-px3.u-py2.c-btn.u-white.u-bg-youtube
            i.u-icon.u-fz-h3.u-mr3 youtube
            span.u-uppercase.u-mt1.u-fw-s-bold siguenos en youtube

          iframe.u-block.u-mx-auto(width='546', height='300', :src="'https://www.youtube.com/embed/'+ currentPost.videoUrl +'?rel=0&showinfo=0'", frameborder='0', allowfullscreen='')
        .u-flex.u-mt4.u-mb5.u-items-center
          span.u-mr2 COMPARTIR:
          share-buttons(:shares="['whatsapp', 'facebook', 'twitter']", :title='currentPost.title')
        //- iframe.u-mb4.u-block.u-mx-auto(v-if='currentPost.videoUrl', width='360', height='202', class='u-hide@laptop', :src="'https://www.youtube.com/embed/'+ currentPost.videoUrl +'?rel=0&showinfo=0'", frameborder='0', allowfullscreen='')

        .fb-comments.u-mb4(
          data-order-by='reverse_time',
          :data-href="currentUrl",
          data-share="true"
          data-numposts='5'
        )

      aside.u-mb4.c-news-aside(class='u-show@laptop')
        .c-news-aside__item(class='u-show@laptop u-relative')

        //- div(class='u-px4 u-py3 u-bg-border u-mb3' v-if='currentPost.videoUrl')
          a.u-flex.u-items-center.u-px3.u-py2.c-btn.u-white.u-bg-youtube
            i.u-icon.u-fz-h3.u-mr3 youtube
            span.u-uppercase.u-mt1.u-fw-s-bold siguenos en youtube

          iframe.u-block.u-mx-auto(width='296', height='167', :src="'https://www.youtube.com/embed/'+ currentPost.videoUrl +'?rel=0&showinfo=0'", frameborder='0', allowfullscreen='')


        app-publicities(
          class='u-show@tablet'
          v-if='secondGroup.length > 0'
          :publicities='secondGroup')

        div(class='u-px4 u-py3 u-bg-border u-mb3')
          p(v-if='company.whatsappNumber' class='c-btn u-bg-whatsapp u-flex u-items-center u-px3 u-white u-py2 u-mb0 u-mt0')
            i(class="u-icon u-mr2 u-fz-h3") whatsapp
            span(class='u-fw-bold u-fz-h4 u-mt1') {{ company.whatsappNumber }}

        div(class='u-px4 u-py3 u-bg-border u-mb3')
          iframe(v-if='company.facebookPage', :src="'https://www.facebook.com/plugins/page.php?href='+ encodeURIComponent(company.facebookPage) + '&tabs=timeline&width=280&height=308&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=1140807346001788'" width="280" height="308" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" class="u-mb2")

        div(class='u-px4 u-py3 u-bg-border u-mb3')
          a(v-if='company.twitterPage' class='twitter-timeline' data-width='280' data-height='400', :href="company.twitterPage") Tweets by RccTacna


    section(class='u-bg-border')
      div(class='o-wrapper u-py5')
        h3(class='u-inline-block u-mt0 u-mb4 u-bg-primary u-white u-uppercase u-px4 u-py2') Noticias relacionadas
        div(class='u-flex u-items-center ')
          button(class='c-btn-nav' id='post-related__prev')
            i(class='u-icon') arrow_extend_left
          div(class='u-flex-1 u-1/12 u-px4')
            swiper(:options='swiperRelated')
              swiper-slide(v-for='(post, index) in postsRelated', :key='index' class='u-block')
                router-link(:to="{ name: 'Post', params: {slug: post.slug} }" class='u-block')
                  figure(class='u-block' v-if='post.imageUrl')
                    img(class='lazyload u-12/12', :src='post.imageUrl', :data-src='post.imageThumbUrl')
                  p(class='u-bg-white u-fw-s-bold u-color-tertiary u-px3 u-py2 u-fz-h6 u-mt0 u-mb0') {{post.title}}
          button(class='c-btn-nav' id='post-related__next')
            i(class='u-icon') arrow_extend_right

    app-footer
    loading(v-if='isLoading')
</template>

<script>
  import { mapGetters } from 'vuex'
  import NavPost from './NavPost'
  import axios from 'axios'

  export default {
    name: 'PostScreen',
    components: { NavPost },

    data () {
      return {
        isLoading: true,
        postsLast: [],
        postsRelated: [],
        secondGroup: [],
        swiperLast: {
          spaceBetween: 20,
          autoplay: 10000,
          slidesPerView: 5,
          navigation: {
            nextEl: '#post-last__next',
            prevEl: '#post-last__prev'
          },
          breakpoints: {
            467: {
              slidesPerView: 1,
              autoHeight: true
            },
            600: {
              slidesPerView: 2
            },
            999: {
              slidesPerView: 3
            }
          }
        },
        swiperRelated: {
          spaceBetween: 20,
          autoplay: 10000,
          slidesPerView: 5,
          navigation: {
            nextEl: '#post-related__next',
            prevEl: '#post-related__prev'
          },
          breakpoints: {
            467: {
              slidesPerView: 1,
              autoHeight: true
            },
            600: {
              slidesPerView: 2
            },
            999: {
              slidesPerView: 3
            }
          }
        },
        swiperPost: {
          // loop: true,
          navigation: {
            nextEl: '#post-cover__next',
            prevEl: '#post-cover__prev'
          }
        },
        currentUrl: window.location.href,
        nextPost: false,
        prevPost: false,
        currentPost: false
      }
    },

    computed: {
      ...mapGetters({
        company: 'company'
      })
    },

    methods: {
      moveDown () {
        window.$('body').animate({scrollTop: window.$('#c-post-detail').offset().top - 63}, '1000', 'swing')
      },

      getPost () {
        axios.get(`${window.API_URL}/posts/${this.$route.params.slug}`)
          .then(({data}) => {
            this.currentPost = data.data
            this.isLoading = false
          })
      },

      getPostsLast () {
        axios.get(`${window.API_URL}/posts/last`)
          .then(({data}) => {
            this.postsLast = data.data
          })
      },

      getRelated () {
        axios.get(`${window.API_URL}/posts/${this.$route.params.slug}/related`)
          .then(({data}) => {
            this.postsRelated = data.data
          })
      },

      getPublicities () {
        axios.get(`${window.API_URL}/publicities`)
          .then(({data}) => {
            this.secondGroup = data.secondGroup
          })
      }
    },

    mounted () {
      setTimeout(() => {
        try {
          window.twttr.widgets.load()
          window.fbAsyncInit()
        } catch (e) {
          console.log(e)
        }
      }, 750)
    },

    beforeRouteEnter (to, from, next) {
      axios.get(`${window.API_URL}/posts/${to.params.slug}`)
        .then(({data}) => {
          next((vm) => {
            vm.currentPost = data.data
            vm.isLoading = false
          })
        })
        .catch(() => {
          next({name: 'NotFound'})
        })
    },

    created () {
      this.getPostsLast()
      this.getPublicities()
    },

    watch: {
      currentPost (val) {
        this.getRelated()
      },

      '$route' (val, oldVal) {
        this.isLoading = true
        this.getPost()
        this.currentUrl = window.location.href
        setTimeout(() => {
          try {
            window.fbAsyncInit()
          } catch (e) {
            console.log(e)
          }
        }, 50)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/screens/Post/components/PostScreen.vue